module.exports = __webpack_public_path__ + "static/img/emil.7e0454f5.png";